import gql from 'graphql-tag';
import {LISTADO_NOTARIOS} from '@/graphQLQueries/UsuarioQueries';
import {LISTADO_MOTIVOS_CANCELACION,LISTADO_MOTIVOS_SUSPENSION} from '@/graphQLQueries/ReclamacionQueries';
import {LISTADO_MOTIVOS_CANCELACION_OPERACION, LISTADO_MOTIVOS_SUSPENSION_OPERACION} from '@/graphQLQueries/OperacionQueries';


export const BOTONERA_ACCIONES_LISTADOS_CON_NOTARIOS = gql(`
   query listadosDropdowns($idioma: String!) {
   ` + LISTADO_MOTIVOS_CANCELACION + `
   ` + LISTADO_MOTIVOS_SUSPENSION + `
   ` + LISTADO_NOTARIOS + `
}`);



export const BOTONERA_ACCIONES_FASE_AMISTOSA_RECLAMACION = gql(`
   mutation notificacionAmistosaReclamacion($agenteUuid:String, $token:String){
   notificacionAmistosaReclamacion(agenteUuid: $agenteUuid, tokenReclamacion:$token){
      statusCode
      message
      errorMessage
   }
}`);      
export const BOTONERA_ACCIONES_VALIDAR_RECLAMACION = gql(`
   mutation validarReclamacion($token:String){
   validarReclamacion(tokenReclamacion:$token){
      statusCode
      message
      errorMessage
   }
}`);        
export const BOTONERA_ACCIONES_RECUPERAR_RECLAMACION = gql(`
   mutation recuperarReclamacion($token:String, $fechaPago:Long, $divisa:String, $totalPendiente:Float){
   recuperarReclamacion(tokenReclamacion:$token, fechaPago:$fechaPago, divisa:$divisa, totalPendiente:$totalPendiente){
      statusCode
      message
      errorMessage
   }
}`);
export const BOTONERA_ACCIONES_EN_NOTARIA_RECLAMACION = gql(`
   mutation asignarNotarioReclamacion($token:String, $notarioUuid:String){
   asignarNotarioReclamacion(tokenReclamacion:$token, notarioUuid:$notarioUuid){
      statusCode
      message
      errorMessage
   }
}`);
export const BOTONERA_ACCIONES_ACTA_PROVISIONAL = gql(`
   mutation actaProvisionalEnviada($token:String){
   actaProvisionalEnviada(tokenReclamacion:$token){
      statusCode
      message
      errorMessage
   }
}`);
export const BOTONERA_ACCIONES_ACTA_DEFINITIVA = gql(`
   mutation actaDefinitivaEnviada($token:String){
   actaDefinitivaEnviada(tokenReclamacion:$token){
      statusCode
      message
      errorMessage
   }
}`);

export const GET_PAISES = gql`
   query getPaises($idioma:String) {
      paises(idioma:$idioma) {
         valor,
         idioma,
         clave
      }
  }
`

export const GET_COD_PROVINCIAS_POR_PAISES = gql`
   query getCodProvinciasPorPaises($clavePais:String,$idioma:String) {
      codProvinciasPorPaises(clavePais:$clavePais,idioma:$idioma) {
         clave,
         valor
      }
  }
`

export const GET_LISTADO_TIPOS_VIA_DIRECCION = gql`
   query getListadoTiposViaDireccion($idioma:String) {
      listadoTiposViaDireccion(idioma:$idioma) {
         valor
         clave
      }
  }
`

export const GET_CNAE_LIST = gql`
   query getListadoTipoCnaesSectores($idioma:String) {
      listadoTipoCnaesSectores {
         sector,
         literalTipoCnae(idioma:$idioma) {
           valor
         }
      }
  }
`
export const GET_CNAE_LIST_BY_SECTOR = gql`
   query listadoTipoCnaesPorSector($sector:String,$idioma:String) {
      listadoTipoCnaesPorSector(sector:$sector) {
         codigo
         literalTipoCnae(idioma:$idioma) {
            valor
         }
      }
  }
`

export const GET_DEBT_ORIGIN_LIST = gql`
   query getListadoOrigenesDeuda($idioma:String) {
      listadoOrigenesDeuda(idioma:$idioma) {
         valor
         clave
      }
  }
`

export const GET_LISTADO_TIPOS_SOCIEDAD = gql`
   query getListadoTiposSociedad($idioma: String) {
      listadoTiposSociedad(idioma: $idioma) {
         codigo
         clave
         valor 
         idioma     
      }
   }
`
export const BOTONERA_ACCIONES_LISTADOS_OPERACION = gql(`
   query listadosDropdowns($idioma: String!) {
   ` + LISTADO_MOTIVOS_CANCELACION_OPERACION + `
   ` + LISTADO_MOTIVOS_SUSPENSION_OPERACION + `
}`);

export const BOTONERA_ACCIONES_CANCELAR_RECLAMACION = gql(`
   mutation cancelar($motivoCancelacion: String, $token:String, $usuarioUuid: String){
   cancelarReclamacion(motivoCancelacion:$motivoCancelacion, tokenReclamacion:$token, usuarioUuid:$usuarioUuid){
      request {
         motivoCancelacion
      }
   }
}`);


export const BOTONERA_ACCIONES_CANCELAR_OPERACION = gql(`
   mutation cancelar($motivoCancelacion: String, $uuidOperacion:String, $usuarioUuid:String){
   cancelarOperacion(motivoCancelacion:$motivoCancelacion, uuidOperacion:$uuidOperacion, usuarioUuid:$usuarioUuid){
      request {
         motivoCancelacion
      }
   }
}`);
export const BOTONERA_ACCIONES_SUSPENDER_RECLAMACION = gql(`
   mutation suspender($fechaLimite: Long, $motivoSuspension: String, $token:String, $usuarioUuid:String){
   suspenderReclamacion(fechaLimite: $fechaLimite, motivoSuspension:$motivoSuspension, tokenReclamacion:$token, usuarioUuid:$usuarioUuid){
      request {
         motivoSuspension
      }
   }
}`);

export const BOTONERA_ACCIONES_REACTIVAR_RECLAMACION = gql(`
   mutation reactivar($token:String){
      reactivarReclamacion(tokenReclamacion:$token){
         request {
            token
         }
   }
}`);
export const BOTONERA_ACCIONES_INCLUIR_RECLAMACION = gql(`
   mutation incluir($token:String){
      incluirReclamacion(tokenReclamacion:$token){
         request {
            token
         }
      }
   }`);


export const BOTONERA_ACCIONES_SUSPENDER_OPERACION = gql(`
   mutation suspender($fechaLimite: Long, $motivoSuspension: String, $uuidOperacion:String, $usuarioUuid:String){
   suspenderOperacion(fechaLimite: $fechaLimite, motivoSuspension:$motivoSuspension, uuidOperacion:$uuidOperacion, usuarioUuid:$usuarioUuid){
      request {
         motivoSuspension
      }
   }
}`);


export const BOTONERA_ACCIONES_RECUPERAR_OPERACION = gql(`
   mutation recuperarOperacion($uuidOperacion:String, $recuperadoAutomatico:Boolean, $usuarioUuid:String){
   recuperarOperacion(uuidOperacion:$uuidOperacion, recuperadoAutomatico:$recuperadoAutomatico, usuarioUuid: $usuarioUuid){
      pago {
         divisa
         fechaPago
         importe
      }
   }
}`);

export const BOTONERA_ACCIONES_PAGO_PARCIAL_RECLAMACION = gql(`
   mutation ordenPagoReclamacion($token:String, $importe:Float, $divisa:String, $noComisiona:Boolean,$filename:String,$fileBase64:String,$usuarioUuid:String, $observaciones:String, $fechaPago:Long ){
      ordenPagoReclamacion(tokenReclamacion:$token, importe:$importe, divisa:$divisa, noComisiona:$noComisiona, filename:$filename, fileBase64:$fileBase64, usuarioUuid:$usuarioUuid, observaciones:$observaciones, fechaPago:$fechaPago ){
         pago {
            divisa
            fechaPago
            importe
         }
      }
}`);


export const BOTONERA_ACCIONES_PAGO_PARCIAL_OPERACION = gql(`
   mutation ordenPagoOperacion($uuidOperacion:String, $importe:Float, $divisa:String,$usuarioUuid:String){
      ordenPagoOperacion(uuidOperacion:$uuidOperacion, importe:$importe, divisa:$divisa, usuarioUuid:$usuarioUuid){
         pago {
            divisa
            fechaPago
            importe
         }
      }
}`);

export const BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO = gql(`
   mutation ordenPagoImpago($ordenPagoImpagoRequest: OrdenPagoImpagoRequestInput){
      ordenPagoImpago(ordenPagoImpagoRequest: $ordenPagoImpagoRequest){
         pago {
            divisa
            fechaPago
            importe
         }
      }
}`);

export const BOTONERA_QUERY_DESCARGA_PDF_BORRADOR_NOTARIA = gql(`
   query pdfBorradorNotaria($token: String!){
      pdfBorradorNotaria(tokenReclamacion:$token) {
         status
         pdf 
      }
}`);


export const BOTONERA_ACCIONES_RECUPERAR_IMPAGO = gql(`
   mutation rectificarImpago($rectificarImpagoRequest: RectificarImpagoRequestInput){
      rectificarImpago(rectificarImpagoRequest: $rectificarImpagoRequest){
         rectificacionInfoReclamacion {
            token
            deudaPendientePrevio
            deudaPendienteActual
            reclamacionRecuperada
            reclamacionRevertida
         }
      }
}`);


export const BOTONERA_ACCIONES_RECUPERAR_PAGO = gql(`
   mutation rectificarPagoImpago($rectificarPagoRequest: RectificarPagoRequestInput){
      rectificarPagoImpago(rectificarPagoRequest: $rectificarPagoRequest){
         rectificacionInfoReclamacionList {
            token
            deudaPendientePrevio
            deudaPendienteActual
            reclamacionRecuperada
            reclamacionRevertida
         }
      }
}`);

export const BOTONERA_ACCIONES_ELIMINAR_PAGO = gql(`
   mutation eliminarPagoImpago($eliminarPagoRequest: EliminarPagoRequestInput){
      eliminarPagoImpago(eliminarPagoRequestInput: $eliminarPagoRequest){
         eliminacionInfoReclamacionList {
            token
         }
      }
}`);
